import React, { useLayoutEffect, useRef, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { twMerge } from 'tailwind-merge'
import { getMotionPreset, SkeletonAnimation } from './skeleton.helpers'

export type SkeletonVariants = 'base'

export type SharedSkeletonProps = {
  loading?: boolean
  skeleton?: React.ReactNode
  variant?: SkeletonVariants
  animation?: SkeletonAnimation
}
export type SkeletonProps = {
  loading?: boolean
  children: React.ReactNode
  skeleton?: React.ReactNode
  className?: string
  height?: number | `min-h-[${number}px]`
  variant?: SkeletonVariants
  animation?: SkeletonAnimation
}

/** ===== Variant renderer ===== */
const SkeletonVariant = (props: { variant?: SkeletonVariants }) => {
  return (
    <div className='h-full w-full animate-pulse rounded-lg bg-slate-200 dark:bg-slate-800' />
  )
}

/** ===== Main wrapper ===== */
export function Skeleton({
  height,
  animation = 'fade',
  ...props
}: SkeletonProps) {
  const preset = getMotionPreset(animation)

  return (
    <div
      style={typeof height === 'number' ? { height } : undefined}
      className={twMerge(
        'relative w-full flex-1 min-w-0',
        typeof height === 'string' ? height : '',
        props.className,
      )}>
      <AnimatePresence initial={false}>
        {props.loading ? (
          <motion.div key='skeleton' {...preset} className='w-full min-w-0'>
            {props.skeleton ?? <SkeletonVariant variant={props.variant} />}
          </motion.div>
        ) : (
          <div className='w-full min-w-0'>{props.children}</div>
        )}
      </AnimatePresence>
    </div>
  )
}
